import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Container,
  Box,
  Paper,
} from '@mui/material';
import {
  Users2,
  BookOpen,
  GraduationCap,
  TrendingUp,
} from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';

const SchoolHome = () => {
  const { language } = useLanguage();
  const { user } = useAuth();

  const text = {
    fr: {
      welcome: 'Bienvenue sur votre espace école',
      schoolName: 'École',
      totalStudents: 'Total Élèves',
      totalClasses: 'Classes',
      totalTeachers: 'Enseignants',
      performance: 'Performance',
      recentActivities: 'Activités Récentes',
      overview: 'Vue d\'ensemble',
    },
    en: {
      welcome: 'Welcome to your school space',
      schoolName: 'School',
      totalStudents: 'Total Students',
      totalClasses: 'Classes',
      totalTeachers: 'Teachers',
      performance: 'Performance',
      recentActivities: 'Recent Activities',
      overview: 'Overview',
    }
  };

  const currentText = text[language as keyof typeof text];

  const stats = [
    {
      title: currentText.totalStudents,
      value: '0',
      icon: Users2,
      color: '#0D3C4C',
      bgColor: '#E3F2FD',
    },
    {
      title: currentText.totalClasses,
      value: '0',
      icon: BookOpen,
      color: '#1976D2',
      bgColor: '#E8F5E9',
    },
    {
      title: currentText.totalTeachers,
      value: '0',
      icon: GraduationCap,
      color: '#388E3C',
      bgColor: '#FFF3E0',
    },
    {
      title: currentText.performance,
      value: '0%',
      icon: TrendingUp,
      color: '#F57C00',
      bgColor: '#FCE4EC',
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, color: '#0D3C4C', mb: 1 }}>
          {currentText.welcome}
        </Typography>
        <Typography variant="h6" sx={{ color: '#666' }}>
          {user?.company?.name || currentText.schoolName}
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card 
                sx={{ 
                  height: '100%',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4,
                  }
                }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: '12px',
                        backgroundColor: stat.bgColor,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mr: 2,
                      }}
                    >
                      <Icon size={24} color={stat.color} />
                    </Box>
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        {stat.title}
                      </Typography>
                      <Typography variant="h5" sx={{ fontWeight: 600, color: stat.color }}>
                        {stat.value}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            {currentText.overview}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {currentText.recentActivities}
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default SchoolHome;
